<template>
  <div class="header-portal">
    <div class="header-portal__topline">
      <content-container>
        <a-row justify="space-between" :gutter="[50, 50]">
          <a-col class="header-portal__logo">
            <main-logo/>
            <input-search
              v-show="isShowSearch"
              class="dark"
              placeholder="Ищите подразделения, сотрудников, публикации"
            />
          </a-col>
          <a-col class="header-portal__menu">
            <top-menu></top-menu>
          </a-col>
        </a-row>
      </content-container>
    </div>
    <content-container class="header-portal__title">
      <slot></slot>
    </content-container>
  </div>
</template>

<script setup>
import {useRoute} from "vue-router";
import TopMenu from "@/views/portal/components/menus/TopMenu.vue";
import MainLogo from "@/views/portal/components/main-logo/MainLogo.vue";
import ContentContainer from "@/views/portal/components/ContentContainer.vue";
import InputSearch from "@/views/portal/components/UI/InputSearch.vue";
import {onMounted, ref, watch} from "vue";

const route = useRoute();
const isShowSearch = ref(false);

const getShowSearch = () => {
  let routeName = route.name;

  if (routeName === 'portal-main-page') return false;
  if (routeName.startsWith('portal-departments')) return false;
  if (routeName.startsWith('portal-persons')) return false;
  if (routeName.startsWith('portal-publications')) return false;
  if (routeName.startsWith('portal-intellectuals')) return false;
  if (routeName.startsWith('portal-search')) return false;

  return true;
}

watch(() => route.name,() => {
  isShowSearch.value = getShowSearch();
});

onMounted(() => {
  isShowSearch.value = getShowSearch();
});
</script>

<style lang="scss" scoped>
.header-portal {
  background: #2d3346;
  color: #ffffff;

  .header-portal__topline {
    padding: 40px;
    border: 1px solid #383d4f;

    .header-portal__logo {
      flex-grow: 1;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      gap: 50px;
    }

    .header-portal__menu {

    }
  }

  .header-portal__title {
    padding: 150px 35px 40px 35px;
    background: #2d3346;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
  }
}
</style>
